<template>
  <div class="products-page">
    <div v-if="loading" class="loading">
      <div class="spinner"></div>
      <p>
        {{ $i18n.t("subscription.product_page_home_loading_txt") }}
      </p>
    </div>

    <div v-else class="product-grid-wrapper">
      <div class="product-grid">
        <ProductCard v-for="product in products" :key="product.Id" :product="product"
          :is-selected="selectedProduct && selectedProduct.Id === product.Id" @select="selectProduct"
          @purchase="purchaseProduct" />
      </div>
    </div>
  </div>
</template>

<script>
import ProductCard from '../components/productCard.vue';
import { api_get_palns, subscriptionApi } from '../services/subscriptionApi.js';

export default {
  name: 'ProductsPage',
  components: {
    ProductCard
  },
  data() {
    return {
      loading: true,
      products: [],
      selectedProduct: null
    };
  },
  async mounted() {
    await this.loadProducts();
  },
  methods: {
    async loadProducts() {
      try {
        var that = this;
        api_get_palns().then(
            (response) => {
                that.handleGetPlansResponse(response);
            },
            (error) => {
                console.error(error);
                that.isLoadingPrevPage = false;
            }
        );
      } catch (error) {
        console.error('Failed to load products:', error);
      } finally {
        this.loading = false;
      }
    },
    handleGetPlansResponse(response) {
      if (response.data.Code === 0) {
        this.products = response.data.Result.Plans.sort((a, b) => {
          const nameA = a.Name.toLowerCase();
          const nameB = b.Name.toLowerCase();

          // 判断是否包含 Plus / Pro
          const isPlusA = nameA.includes("plus");
          const isPlusB = nameB.includes("plus");
          const isProA  = nameA.includes("pro");
          const isProB  = nameB.includes("pro");

          // 赋值排序权重 (0 无 Plus/Pro, 1 Plus, 2 Pro)
          const weightA = isPlusA ? 1 : isProA ? 2 : 0;
          const weightB = isPlusB ? 1 : isProB ? 2 : 0;

          // 先按权重排：无 > Plus > Pro
          if (weightA !== weightB) {
            return weightA - weightB;
          }

          // 同类情况下按 Priority 从小到大
          return a.Priority - b.Priority;
        });
        for (let i = 0; i < this.products.length; i++) {
          this.products[i].Description = this.splitStringToArray(this.products[i].Description);
        }
        localStorage.setItem('productList', JSON.stringify(this.products ? this.products : []));
      } else {
        console.error('Failed to get plans:', response.message);
      }
    },
    splitStringToArray(str) {
      if (!str) return [];
      const separator = str.includes('，') ? '，' : ', ';
      
      return str
        .split(separator)
        .map(item => item.trim())
        .filter(item => item !== '');
    },
    selectProduct(product) {
      this.selectedProduct = product;
    },
    purchaseProduct(product) {
      this.$router.push({
        name: 'checkout',
        params: { product: product }
      });
    }
  }
}
</script>

<style scoped>
.products-page {
  /* 移除固定高度，让组件适应父容器 */
  display: flex;
  flex-direction: column;
  min-height: 0; /* 允许 flex 子项收缩 */
  flex: 1; /* 占据剩余空间 */
}

.product-grid-wrapper {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 5px 15px;
  /* 设置最大高度以确保滚动生效 */
  max-height: calc(100vh - 200px); /* 减去 header 等其他元素的高度 */
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 20px;
  margin-top: 5px;
  padding: 0;
}

.loading {
  text-align: center;
  padding: 50px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 自定义滚动条样式 */
.product-grid-wrapper::-webkit-scrollbar {
  width: 6px;
}

.product-grid-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.product-grid-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.product-grid-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

@media (max-width: 268px) {
  .product-grid {
    grid-template-columns: 1fr;
  }
}
</style>